import produce from "immer";
import { IStoreState } from "..";
import { LoadState } from "../../constants/enums";
import {
  CLEAR_GATE_ENTRY_STATE,
  CLEAR_SINGLE_GATE_ENTRY,
  defaultGateEntry,
  defaultGateEntryState,
  FETCH_GATE_ENTRY_LIST_FAILED,
  FETCH_GATE_ENTRY_LIST_PROGRESS,
  FETCH_GATE_ENTRY_LIST_SUCCESS,
  FETCH_SINGLE_GATE_ENTRY_FAILED,
  FETCH_SINGLE_GATE_ENTRY_PROGRESS,
  FETCH_SINGLE_GATE_ENTRY_SUCCESS,
  GateEntryActions,
} from ".";

export const gateEntryReducer = (
  state: IStoreState["gateEntry"] = defaultGateEntryState,
  action: GateEntryActions,
) => {
  switch (action.type) {
    case FETCH_GATE_ENTRY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.gate_entry_list.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_GATE_ENTRY_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.gate_entry_list.loading = LoadState.Loaded;
        draftState.gate_entry_list.list = data;
        draftState.gate_entry_list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_GATE_ENTRY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.gate_entry_list.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_SINGLE_GATE_ENTRY_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.single_gate_entry.loading = LoadState.InProgress;
      });
      return newState;
    }
    case FETCH_SINGLE_GATE_ENTRY_SUCCESS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_gate_entry.loading = LoadState.Loaded;
        draftState.single_gate_entry.data = data;
      });
      return newState;
    }
    case FETCH_SINGLE_GATE_ENTRY_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.single_gate_entry.loading = LoadState.Failed;
        draftState.single_gate_entry.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_SINGLE_GATE_ENTRY: {
      const newState = produce(state, (draftState) => {
        draftState.single_gate_entry.loading = LoadState.NotLoaded;
        draftState.single_gate_entry.data = defaultGateEntry;
      });
      return newState;
    }
    case CLEAR_GATE_ENTRY_STATE: {
      return defaultGateEntryState;
    }

    default: {
      return state;
    }
  }
};
